import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { supabase } from "@/ajax/clients/supabase";
import { MfaSetup } from "@/features/mfa/MfaSetup";

const searchSchema = z.object({
  // Internal path to return to once the second factor is verified.
  redirect: z
    .string()
    .regex(
      // eslint-disable-next-line no-control-regex -- intentionally rejects control chars to harden the internal-redirect path
      /^\/(?!\/)[^\u0000-\u001f\u007f\\]*$/,
      "redirect must be an internal path",
    )
    .optional(),
});

export const Route = createFileRoute("/auth/mfa/")({
  validateSearch: searchSchema,
  beforeLoad: async () => {
    // The MFA screen requires an authenticated (at least aal1) session. If the
    // user has no session at all, send them to sign in first.
    const { data } = await supabase.auth.getSession();
    if (!data.session) {
      throw redirect({ to: "/auth-org/signin", reloadDocument: true });
    }
  },
  component: MfaRouteComponent,
});

function MfaRouteComponent() {
  const { redirect: redirectTo } = Route.useSearch();
  return <MfaSetup redirectTo={redirectTo ?? "/"} />;
}
